import script from "./progress.vue?vue&type=script&setup=true&lang=js"
export * from "./progress.vue?vue&type=script&setup=true&lang=js"

import "./progress.vue?vue&type=style&index=0&id=630c4bd3&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-630c4bd3"]])

export default __exports__